const getDefaultState = () => {
    return {
        wohnen: {
            path: "wohnen",
            title: "Wohnen",
            motive: "Mein Zuhause",
            magazinTag: "magazin_wohnen",
            magazinTitle: "Mein Zuhause"
        },
        mobilitaet: {
            path: "mobilitaet",
            title: "Mobilität",
            motive: "Meine Mobilität",
            magazinTag: "magazin_mobilitaet",
            magazinTitle: "Meine Mobilität"
        },
        gesundheit: {
            path: "gesundheit",
            title: "Gesundheit",
            motive: "Meine Gesundheit",
            magazinTag: "magazin_gesundheit",
            magazinTitle: "Meine Gesundheit"
        },
        geld: {
            path: "geld",
            title: "Geld",
            motive: "Mein Geld",
            magazinTag: "magazin_bausparen",
            magazinTitle: "Mein Geld"
        },
        zukunft: {
            path: "zukunft",
            title: "Zukunft",
            motive: "Meine Zukunft",
            magazinTag: "magazin_zukunft",
            magazinTitle: "Meine Zukunft"
        },
        karriere: {
            path: "karriere",
            title: "Karriere",
            motive: "Meine Karriere",
            magazinTag: "magazin_karriere",
            magazinTitle: "Meine Karriere"
        }
    };
};

const state = getDefaultState();

export default {
    state
};
